let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bTVim")).then(() => parcelRequire('k7UXO'));